<template>
  <div class="tc-container">
    <div class="_flex">
      <div class="tc-chart">
        <div ref="myChart" class="myChart"></div>
        <img
          class="circle"
          ref="circle"
          src="../../../assets/wifi_images/left-out-border.png"
          alt=""
        />
        <img
          class="circle"
          ref="circle1"
          src="../../../assets/wifi_images/left-in-border.png"
          alt=""
        />
      </div>
      <div>
        <div class="_div1">景区车位总数（个）</div>
        <div class="_colr1">1568</div>
        <div class="_div2">车位已使用（个）</div>
        <div class="_colr2">988</div>
        <div class="_div3">剩余车位（个））</div>
        <div class="_colr3">580</div>
      </div>
    </div>
  </div>
</template>
<script>
  import 'echarts-liquidfill'

  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          backgroundColor: 'rgba(0, 0, 0, 0)',
          title: [
            {
              text: '利用率',
              x: 42 - 2 + '%',
              y: '52%',
              textStyle: {
                fontSize: 14,
                fontWeight: '100',
                color: '#88E5D0',
                lineHeight: 16,
                textAlign: 'center',
              },
            },
          ],
          series: [
            {
              type: 'liquidFill',
              radius: '50%',
              center: ['50%', '52%'],
              color: [
                {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0, 255, 162, 0.2)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(0, 255, 162, 0.6)',
                    },
                  ],
                  globalCoord: false,
                },
              ],
              data: [0.45, 0.45 + 0.05], // data个数代表波浪数
              backgroundStyle: {
                color: {
                  type: 'radial', // linear 线性渐变  radial径向渐变
                  x: 0.5, // 0.5为正中心，如果小于渐变中心靠左
                  y: 0.5, // 0.5为正中心，如果小于渐变中心靠上
                  r: 0.8,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0, 0, 0, 0)', // 0% 处的颜色
                    },
                    {
                      offset: 0.8,
                      color: 'rgba(0, 255, 162, 0.15)', // 100% 处的颜色
                    },
                  ],
                },
              },
              label: {
                normal: {
                  textStyle: {
                    fontSize: 20,
                    color: '#fff',
                  },
                },
              },
              outline: {
                // show: false
                borderDistance: 0,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: 'rgba(0, 255, 162, 0.3)',
                },
              },
            },
          ],
        })
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
        // 圆环转动
        this.$animejs({
          targets: this.$refs.circle,
          easing: 'linear',
          loop: true,
          rotate: 360,
          duration: 10000,
        })
        // 圆环转动
        this.$animejs({
          targets: this.$refs.circle1,
          easing: 'linear',
          loop: true,
          rotate: -360,
          duration: 10000,
        })
      },
    },
    beforeDestroy() {
      this.$animejs.remove('.circle')
    },
  }
</script>
<style lang="scss" scoped>
  @mixin currency($a1) {
    font-size: 12px;
    white-space: nowrap;
    color: #fff;
    &::before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 5px;
      background: $a1;
      border-radius: 50%;
      margin-right: 5px;
      position: relative;
      bottom: 2px;
    }
  }
  @mixin dyestuff($a1) {
    font-size: 26px;
    color: $a1;
    margin: 10px 0 20px 0;
  }
  .tc-container {
    height: 220px;
    width: 100%;
    .myChart {
      height: 220px;
      width: 100%;
    }
    .tc-chart {
      width: 100%;
      position: relative;
    }
    .circle {
      position: absolute;
      z-index: 4;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
    ._flex {
      display: flex;
      width: 100%;
    }
    ._div1 {
      @include currency(#20e897);
    }
    ._div2 {
      @include currency(#ffc600);
    }
    ._div3 {
      @include currency(#008aff);
    }
    ._colr1 {
      @include dyestuff(#20e897);
    }
    ._colr2 {
      @include dyestuff(#ffc600);
    }
    ._colr3 {
      @include dyestuff(#008aff);
    }
  }
</style>
